var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.833252C3.32065 0.833252 0.333984 3.81992 0.333984 7.49992C0.333984 11.1799 3.32065 14.1666 7.00065 14.1666C10.6807 14.1666 13.6673 11.1799 13.6673 7.49992C13.6673 3.81992 10.6807 0.833252 7.00065 0.833252ZM7.66732 10.8333H6.33398V9.49992H7.66732V10.8333ZM7.66732 8.16659H6.33398V4.16659H7.66732V8.16659Z",
    fill: "#C91B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkIcon);
export default __webpack_public_path__ + "static/media/ExclamationMarkIcon.d0a95f25.svg";
export { ForwardRef as ReactComponent };